var exports = {
  "x": "xdde3148b--f3aaf6--button",
};

module.exports = exports;
